// import axios from 'axios';
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
// import { Context } from '../../utils/context';
// import { useContext } from 'react';
// import { useSelector } from 'react-redux';
// import { useDispatch } from 'react-redux';
// import { loginuser,logoutuser } from '../../utils/feature/userSlice';
// import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
// import jwt_decode from "jwt-decode";

// function Signup() {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         gender: '',
//         password: '',
//         country: '',
//         phoneNumber: ''
//     });

//     const navigate = useNavigate();
//     const {enqueueSnackbar} = useSnackbar();
//     const dispatch = useDispatch();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });
//     };

//     const handleSubmit =  async(e) => {
//         try{
//             await axios.post(BASE_URL + "/users/newuser",formData).then((res)=>{

//               dispatch(loginuser(res.data))
//               enqueueSnackbar("login succesfull", { variant: "succes" });
//               navigate("/")

//           })

//           }
//           catch(error){
//             enqueueSnackbar(error, { variant: "error" });
//             console.log(error)
//           }

//     };

//     return (
//         <section className="min-h-screen  z-50 flex   flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 fixed w-full top-0">
//             <div className="container flex  flex-col  gap-10   items-center justify-center  h-full px-6 mx-auto">
//                 <form className="w-full max-w-md" >
//                     <div className="relative flex items-center mt-8">

//                         <input
//                             type="text"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                             className="block w-full py-3 text-black bg-white border rounded-lg px-11  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Username"
//                         />
//                     </div>

//                     <div className="relative flex items-center mt-6">

//                         <input
//                             type="email"
//                             name="email"
//                             value={formData.email}
//                             onChange={handleChange}
//                             className="block w-full py-3 text-black bg-white border rounded-lg px-11  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Email address"
//                         />
//                     </div>
//                     <div className="relative flex items-center mt-6">

//                         <input
//                             type="text"
//                             name="gender"
//                             value={formData.gender}
//                             onChange={handleChange}
//                             className="block w-full py-3 text-black bg-white border rounded-lg px-11  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Gender"
//                         />
//                     </div>
//                     <div className="relative flex items-center mt-6">

//                         <input
//                             type="text"
//                             name="phoneNumber"
//                             value={formData.phoneNumber}
//                             onChange={handleChange}
//                             className="block w-full py-3 text-black bg-white border rounded-lg px-11  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Phone no"
//                         />
//                     </div>

//                     <div className="relative flex items-center mt-4">

//                         <input
//                             type="text"
//                             name="password"
//                             value={formData.password}
//                             onChange={handleChange}
//                             className="block w-full px-10 py-3 text-black bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Password"
//                         />
//                     </div>

//                     <div className="relative flex items-center mt-4">

//                         <input
//                             type="text"
//                             name="country"
//                             value={formData.country}
//                             onChange={handleChange}
//                             className="block w-full px-10 py-3 text-black bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
//                             placeholder="Country"
//                         />
//                     </div>

//                     <div className="mt-6">
//                         <button onClick={()=>handleSubmit()} type="button" className="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50">
//                             Sign Up
//                         </button>
//                         <div className="mt-6 text-center ">
//                             <div onClick={() => navigate('/login')} className="text-sm cursor-pointer text-blue-500  dark:text-blue-400">
//                                 Already have an account?
//                             </div>
//                         </div>
//                     </div>
//                 </form>
//                 <div>

// <GoogleOAuthProvider clientId="4278052967-26g3noe5vu29aafk0jqopht00i26d1pj.apps.googleusercontent.com">
// <GoogleLogin
// onSuccess= {async credentialResponse => {
// var decoded = jwt_decode(credentialResponse.credential);

// console.log(decoded);
// const option ={
// name:decoded.name,
// email:decoded.email,
// password:"Shubham@1",
// gender:"male",

// }
// try{

// await axios.post(BASE_URL + "/users/newuser",option).then((res)=>{

// dispatch(loginuser(res.data))
// enqueueSnackbar("login succesfull", { variant: "succes" });
// navigate("/")

// })

// }
// catch(error){
// enqueueSnackbar(error, { variant: "error" });
// console.log(error)
// }
// // console.log(credentialResponse);
// }}
// onError={() => {
// console.log('Login Failed');
// }}
// >

// </GoogleLogin></GoogleOAuthProvider>
// </div>
//             </div>

//         </section>
//     );

//                 }

// export default Signup;

import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { loginuser, logoutuser } from "../../utils/feature/userSlice";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import { BASE_URL } from "../../utils/BaseURL";

function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    gender: "",
    password: "",
    country: "India",
    phoneNumber: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    try {
      await axios.post(BASE_URL + "/users/newuser", formData).then((res) => {
        if (res?.status === 201) {
          dispatch(loginuser(res.data));
          enqueueSnackbar("User Registered successfully", {
            variant: "success",
          });
          navigate("/");
        }
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar(error?.response?.data?.message || error, {
        variant: "error",
      });
    }
  };

  return (
    <section className="min-h-screen z-50 flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 fixed w-full top-0">
      <div className="container flex flex-col gap-10 items-center justify-center h-full px-6 mx-auto">
        <form className="w-full max-w-md">
          <div className="relative flex items-center mt-8">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="block w-full py-3 text-black bg-white border rounded-lg px-11 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
              placeholder="Username"
            />
          </div>

          <div className="relative flex items-center mt-6">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="block w-full py-3 text-black bg-white border rounded-lg px-11 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
              placeholder="Email address"
            />
          </div>

          <div className="relative flex items-center mt-6">
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="block w-full py-3 text-black bg-white border rounded-lg px-11 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="relative flex items-center mt-6">
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="block w-full py-3 text-black bg-white border rounded-lg px-11 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
              placeholder="Phone no"
            />
          </div>

          <div className="relative flex items-center mt-4">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="block w-full px-10 py-3 text-black bg-white border rounded-lg dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
              placeholder="Password"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.6 4.6a9 9 0 010 14.8"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 17.8V19a2 2 0 104 0v-1.2"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* <div className="relative flex items-center mt-4">
                        <input
                            type="text"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            className="block w-full px-10 py-3 text-black bg-white border rounded-lg dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            placeholder="Country"
                        />
                    </div> */}
          <div className="relative flex items-center mt-4">
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="block w-full px-10 py-3 text-black bg-white border rounded-lg dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
              <option value="India">India</option>
            </select>
          </div>

          <div className="mt-6">
            <button
              onClick={() => handleSubmit()}
              type="button"
              className="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
            >
              Sign Up
            </button>
            <div className="mt-6 text-center ">
              <div
                onClick={() => navigate("/login")}
                className="text-sm cursor-pointer text-blue-500  dark:text-blue-400"
              >
                Already have an account?
              </div>
            </div>
          </div>
        </form>
        <div>
          <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
            <GoogleLogin
              onSuccess={async (credentialResponse) => {
                var decoded = jwt_decode(credentialResponse.credential);
                console.log(decoded);
                const option = {
                  name: decoded.name,
                  email: decoded.email,
                  password: "Shubham@1",
                  gender: "male",
                };
                try {
                  await axios
                    .post(BASE_URL + "/users/newuser", option)
                    .then((res) => {
                      dispatch(loginuser(res.data));
                      enqueueSnackbar("Login successful", {
                        variant: "success",
                      });
                      navigate("/");
                    });
                } catch (error) {
                  enqueueSnackbar(error, { variant: "error" });
                  console.log(error);
                }
              }}
              onError={() => {
                console.log("Login Failed");
              }}
            />
          </GoogleOAuthProvider>
        </div>
      </div>
    </section>
  );
}

export default Signup;
